import React from "react";
import { useTranslation } from "react-i18next";

import SectionTitle from "../shared/components/sectionTitle";
import DevelopersCard from "./card";

import { developersData } from "./developers";

import "./style.css";

const Developers = () => {
  const { i18n } = useTranslation();

  return (
    <div className="reception_wrapper">
      <div
        style={{ alignItems: "start" }}
        className="content_wrapper reception_container"
      >
        <SectionTitle title="Dasturchilar" />
        <div className="news_box">
          {developersData.map((developer) => {
            return (
              <DevelopersCard
                key={`1331${developer.id}`}
                fullName={developer.name[`${i18n.language}`]}
                job={developer.job[`${i18n.language}`]}
                phone={developer.phone}
                email={developer.email}
                telegram={developer.telegram}
                image={developer.image}
                website={developer.website}
                linkedin={developer.linkedin}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Developers;
